import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Task_$reflection } from "../Shared/SharedModels.jsx";
import { record_type, option_type, int32_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { tryFind, sortBy, collect, map, append } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { useCtx } from "../Context.jsx";
import { toArray, add, remove, union, ofArray, difference, contains, filter, count as count_1, empty } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { numberHash, createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { map as map_2, value as value_211, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { take, length, collect as collect_1, map as map_1, empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { Button, DialogActions, Body1Strong, Subtitle2, Input, DialogContent, Title3, DialogTitle, DialogBody, DialogSurface, Dialog, Badge, tokens, Caption2, Body1, Checkbox } from "@fluentui/react-components";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { singleton as singleton_1, ofArray as ofArray_1 } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { BookOpenRegular, SearchRegular } from "@fluentui/react-icons";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Task } from "../ApiClient.jsx";

function stopClick(child) {
    return createElement("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
        },
        onClick: (e) => {
            e.stopPropagation();
        },
        children: reactApi.Children.toArray([child]),
    });
}

class TaskNode extends Record {
    constructor(Task, TrackId, LevelId, CourseId) {
        super();
        this.Task = Task;
        this.TrackId = (TrackId | 0);
        this.LevelId = (LevelId | 0);
        this.CourseId = CourseId;
    }
}

function TaskNode_$reflection() {
    return record_type("Track.GrantTasksDialog.TaskNode", [], TaskNode, () => [["Task", Task_$reflection()], ["TrackId", int32_type], ["LevelId", int32_type], ["CourseId", option_type(int32_type)]]);
}

function tasksInLevel(level, trackId) {
    return append(map((t) => (new TaskNode(t, trackId, level.Id, undefined)), level.Tasks), collect((tlc) => map((t_1) => (new TaskNode(t_1, trackId, level.Id, tlc.Course.Id)), tlc.Course.Tasks), level.TrackLevelCourses));
}

function nodeMatches(q, node) {
    if (isNullOrWhiteSpace(q)) {
        return true;
    }
    else {
        return node.Task.Name.toLocaleLowerCase().indexOf(q.toLocaleLowerCase()) >= 0;
    }
}

export function GrantTasksDialog(grantTasksDialogInputProps) {
    let elems_16, el_44, elems_15, el_42, elems_14, el_28, elems_10, el_26, el_34, elems_12, el_32, el_30, elems_11, el_40, elems_13, el_36, el_38, elemsToUse;
    const onSaved = grantTasksDialogInputProps.onSaved;
    const onClose = grantTasksDialogInputProps.onClose;
    const isOpen = grantTasksDialogInputProps.isOpen;
    const completedTasks = grantTasksDialogInputProps.completedTasks;
    const userTracks = grantTasksDialogInputProps.userTracks;
    const user = grantTasksDialogInputProps.user;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const initial = empty({
        Compare: comparePrimitives,
    });
    patternInput_1 = reactApi.useState(initial);
    const setSelected = patternInput_1[1];
    const selected = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const setSearch = patternInput_2[1];
    const search = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsSaving = patternInput_3[1];
    const isSaving = patternInput_3[0];
    const dependencies = [isOpen, user.Id];
    reactApi.useEffect(() => {
        if (isOpen) {
            setSelected(empty({
                Compare: comparePrimitives,
            }));
            setSearch("");
            setIsSaving(false);
        }
    }, dependencies);
    const isCompleted = (taskId) => completedTasks.some((t) => (t.Id === taskId));
    const newlyCheckedCount = count_1(filter((id) => !isCompleted(id), selected)) | 0;
    const bulkToggle = (nodes) => {
        const grantable = nodes.filter((n) => !isCompleted(n.Task.Id));
        if (grantable.length === 0) {
        }
        else if (grantable.every((n_1) => contains(n_1.Task.Id, selected))) {
            setSelected(difference(selected, ofArray(map((n_2) => n_2.Task.Id, grantable, Int32Array), {
                Compare: comparePrimitives,
            })));
        }
        else {
            setSelected(union(selected, ofArray(map((n_3) => n_3.Task.Id, grantable, Int32Array), {
                Compare: comparePrimitives,
            })));
        }
    };
    const parentAllChecked = (nodes_1) => {
        const grantable_1 = nodes_1.filter((n_4) => !isCompleted(n_4.Task.Id));
        if (grantable_1.length === 0) {
            return true;
        }
        else {
            return grantable_1.every((n_5) => contains(n_5.Task.Id, selected));
        }
    };
    const parentLocked = (nodes_2) => {
        if (nodes_2.every((n_6) => isCompleted(n_6.Task.Id))) {
            return nodes_2.length > 0;
        }
        else {
            return false;
        }
    };
    const renderTaskRow = (node) => {
        let elems_1;
        const completed = isCompleted(node.Task.Id);
        const checked$0027 = completed ? true : contains(node.Task.Id, selected);
        return createElement("div", createObj(ofArray_1([["key", `task-${node.TrackId}-${node.LevelId}-${defaultArg(node.CourseId, 0)}-${node.Task.Id}`], ["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
            padding: ((4 + "px ") + 8) + "px",
        }], (elems_1 = toList(delay(() => {
            let el;
            return append_1(singleton(stopClick((el = Checkbox, createElement(el, {
                checked: checked$0027,
                disabled: completed,
                onChange: (_arg_1, c) => {
                    const _arg = Checkbox_toBool(c);
                    const taskId_1 = node.Task.Id | 0;
                    if (isCompleted(taskId_1)) {
                    }
                    else if (contains(taskId_1, selected)) {
                        setSelected(remove(taskId_1, selected));
                    }
                    else {
                        setSelected(add(taskId_1, selected));
                    }
                },
            })))), delay(() => {
                let elems;
                return append_1(singleton(createElement("div", createObj(ofArray_1([["style", {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                }], (elems = toList(delay(() => {
                    let el_2;
                    return append_1(singleton((el_2 = Body1, createElement(el_2, {
                        children: node.Task.Name,
                    }))), delay(() => {
                        let el_4;
                        return node.Task.VerificationRequired ? singleton((el_4 = Caption2, createElement(el_4, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                            },
                            children: "Krever kursholder",
                        }))) : empty_1();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let el_6;
                    return completed ? singleton((el_6 = Badge, createElement(el_6, {
                        color: "success",
                        size: "small",
                        appearance: "tint",
                        children: "Fullført",
                    }))) : empty_1();
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    };
    const el_46 = Dialog;
    return createElement(el_46, createObj(ofArray_1([["open", isOpen], ["modalType", "modal"], ["onOpenChange", (_arg_9, value_1_14) => {
        if (!value_1_14.open) {
            onClose();
        }
    }], (elems_16 = [(el_44 = DialogSurface, createElement(el_44, createObj(ofArray_1([["style", {
        maxWidth: 720,
        maxHeight: 90 + "vh",
        display: "flex",
        flexDirection: "column",
        padding: 0,
    }], (elems_15 = [(el_42 = DialogBody, createElement(el_42, createObj(ofArray_1([["style", {
        padding: ((16 + "px ") + 20) + "px",
        gap: 12 + "px ",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
    }], (elems_14 = [(el_28 = DialogTitle, createElement(el_28, createObj(singleton_1((elems_10 = [(el_26 = Title3, createElement(el_26, {
        children: `Tildel oppgaver — ${user.FirstName} ${user.LastName}`,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))]))))), (el_34 = DialogContent, createElement(el_34, createObj(ofArray_1([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
        overflow: "hidden",
    }], (elems_12 = [(el_32 = Input, createElement(el_32, {
        contentBefore: (el_30 = SearchRegular, createElement(el_30, {})),
        placeholder: "Søk oppgave, kurs eller nivå",
        value: search,
        onChange: (_arg_10, value_1_18) => {
            setSearch(value_1_18.value);
        },
    })), createElement("div", createObj(ofArray_1([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
        overflowY: "auto",
        minHeight: 0,
        paddingRight: 4,
    }], (elems_11 = ofArray_1(map((track_1) => {
        let elems_9;
        const levels = sortBy((_arg_6) => _arg_6.Order, track_1.Track.TrackLevels, {
            Compare: comparePrimitives,
        });
        const trackNodes = collect((l) => tasksInLevel(l, track_1.Track.Id), levels);
        if (!(isNullOrWhiteSpace(search) ? true : trackNodes.some((node_4) => nodeMatches(search, node_4)))) {
            return defaultOf();
        }
        else {
            const trackChecked = parentAllChecked(trackNodes);
            return createElement("div", createObj(ofArray_1([["key", `track-${track_1.Track.Id}`], ["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                padding: 8,
                border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                borderRadius: 6,
            }], (elems_9 = toList(delay(() => {
                let elems_8, el_22, el_24;
                return append_1(singleton(createElement("div", createObj(ofArray_1([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 8 + "px ",
                }], (elems_8 = [stopClick((el_22 = Checkbox, createElement(el_22, {
                    checked: trackChecked,
                    disabled: parentLocked(trackNodes),
                    onChange: (_arg_8, c_3) => {
                        const _arg_7 = Checkbox_toBool(c_3);
                        bulkToggle(trackNodes);
                    },
                }))), (el_24 = Subtitle2, createElement(el_24, {
                    children: track_1.Track.Name,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => map_1((level_1) => {
                    let elems_7;
                    const track = track_1;
                    const level = level_1;
                    const allNodes = tasksInLevel(level, track.Track.Id);
                    const filtered_1 = allNodes.filter((node_2) => nodeMatches(search, node_2));
                    if ((filtered_1.length === 0) && !isNullOrWhiteSpace(search)) {
                        return defaultOf();
                    }
                    else {
                        const levelChecked = parentAllChecked(allNodes);
                        const isCurrent = level.Id === track.CurrentTrackLevelId;
                        const standalone = allNodes.filter((n_7) => (n_7.CourseId == null));
                        const byCourse = Array_groupBy((n_9) => value_211(n_9.CourseId), allNodes.filter((n_8) => (n_8.CourseId != null)), {
                            Equals: (x_4, y_4) => (x_4 === y_4),
                            GetHashCode: numberHash,
                        });
                        return createElement("div", createObj(ofArray_1([["key", `level-${level.Id}`], ["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 6 + "px ",
                            padding: 8,
                            backgroundColor: isCurrent ? tokens.colorNeutralBackground2 : tokens.colorNeutralBackground1,
                            borderRadius: 4,
                        }], (elems_7 = toList(delay(() => {
                            let elems_5;
                            return append_1(singleton(createElement("div", createObj(ofArray_1([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 8 + "px ",
                            }], (elems_5 = toList(delay(() => {
                                let el_16;
                                return append_1(singleton(stopClick((el_16 = Checkbox, createElement(el_16, {
                                    checked: levelChecked,
                                    disabled: parentLocked(allNodes),
                                    onChange: (_arg_5, c_2) => {
                                        const _arg_4 = Checkbox_toBool(c_2);
                                        bulkToggle(allNodes);
                                    },
                                })))), delay(() => {
                                    let el_18;
                                    return append_1(singleton((el_18 = Body1Strong, createElement(el_18, {
                                        children: `Nivå ${level.Order} — ${level.Name}`,
                                    }))), delay(() => {
                                        let el_20;
                                        return isCurrent ? singleton((el_20 = Badge, createElement(el_20, {
                                            size: "small",
                                            appearance: "tint",
                                            color: "brand",
                                            children: "Nåværende",
                                        }))) : empty_1();
                                    }));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                                let elems_6;
                                return append_1((standalone.length > 0) ? singleton(createElement("div", createObj(ofArray_1([["style", {
                                    paddingLeft: 24,
                                }], (elems_6 = ofArray_1(map(renderTaskRow, standalone.filter((node_3) => nodeMatches(search, node_3)))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty_1(), delay(() => collect_1((matchValue) => {
                                    let courseName, nodes_3, filtered, parentChecked, elems_4, elems_2, el_8, el_10, el_12, el_14, elems_3;
                                    const courseId_2 = matchValue[0] | 0;
                                    return singleton((courseName = defaultArg(map_2((tlc_1) => tlc_1.Course.Name, tryFind((tlc) => (tlc.Course.Id === courseId_2), level.TrackLevelCourses)), "Kurs"), (nodes_3 = matchValue[1], (filtered = nodes_3.filter((node_1) => nodeMatches(search, node_1)), (filtered.length === 0) ? defaultOf() : ((parentChecked = parentAllChecked(nodes_3), createElement("div", createObj(ofArray_1([["key", `course-${courseId_2}`], ["style", {
                                        display: "flex",
                                        flexDirection: "column",
                                        paddingLeft: 16,
                                        borderLeft: (((2 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                                    }], (elems_4 = [createElement("div", createObj(ofArray_1([["style", {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8 + "px ",
                                        padding: ((4 + "px ") + 8) + "px",
                                    }], (elems_2 = [stopClick((el_8 = Checkbox, createElement(el_8, {
                                        checked: parentChecked,
                                        disabled: parentLocked(nodes_3),
                                        onChange: (_arg_3, c_1) => {
                                            const _arg_2 = Checkbox_toBool(c_1);
                                            bulkToggle(nodes_3);
                                        },
                                    }))), (el_10 = BookOpenRegular, createElement(el_10, {
                                        fontSize: 16,
                                    })), (el_12 = Body1Strong, createElement(el_12, {
                                        children: courseName,
                                    })), (el_14 = Badge, createElement(el_14, {
                                        color: "informative",
                                        size: "small",
                                        children: "Kurs",
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray_1([["style", {
                                        paddingLeft: 24,
                                    }], (elems_3 = ofArray_1(map(renderTaskRow, filtered)), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))))))));
                                }, byCourse)));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
                    }
                }, levels)));
            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
        }
    }, userTracks)), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))), (el_40 = DialogActions, createElement(el_40, createObj(singleton_1((elems_13 = [(el_36 = Button, createElement(el_36, {
        appearance: "secondary",
        children: "Avbryt",
        disabled: isSaving,
        onClick: (_arg_11) => {
            onClose();
        },
    })), (el_38 = Button, createElement(el_38, {
        appearance: "primary",
        disabled: (newlyCheckedCount === 0) ? true : isSaving,
        children: (newlyCheckedCount === 0) ? "Tildel" : ((newlyCheckedCount === 1) ? "Tildel 1 oppgave" : (`Tildel ${newlyCheckedCount} oppgaver`)),
        onClick: (_arg_12) => {
            if (newlyCheckedCount === 0) {
            }
            else {
                setIsSaving(true);
                const pr = tap((res) => {
                    setIsSaving(false);
                    if (res.tag === 1) {
                        if (res.fields[0].tag === 0) {
                            errorToast(setCtx, "grantTasksTaskNotFound", "Ugyldig oppgave", "En av oppgavene som skulle tildeles var ugyldig", undefined);
                        }
                        else {
                            errorToast(setCtx, "grantTasksUserNotFound", "Ugyldig bruker", "Bruker må være godkjent i systemet", undefined);
                        }
                    }
                    else {
                        onSaved(res.fields[0]);
                        successToast(setCtx, "grantTasksSuccess", "Oppgaver tildelt", "");
                        onClose();
                    }
                }, startAsPromise(Task.CompleteTasksForUser(toArray(filter((id_1) => !isCompleted(id_1), selected)), user.Id)));
                void (pr.catch((e) => {
                    setIsSaving(false);
                    toastServerError(setCtx, e);
                }));
            }
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], (elemsToUse = ((length(elems_16) <= 2) ? elems_16 : take(2, elems_16)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=GrantTasksDialog.jsx.map
